'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _roles = require('../actions/roles');

var _roleCategories = require('../actions/roleCategories');

var _RolesForm = require('../components/roles/RolesForm');

var _RolesForm2 = _interopRequireDefault(_RolesForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditRole = function (_React$Component) {
	_inherits(EditRole, _React$Component);

	function EditRole(props) {
		_classCallCheck(this, EditRole);

		var _this = _possibleConstructorReturn(this, (EditRole.__proto__ || Object.getPrototypeOf(EditRole)).call(this, props));

		_this.editRole = _this.editRole.bind(_this);
		_this.redirectToDashboard = _this.redirectToDashboard.bind(_this);
		_this.cancelEdit = _this.cancelEdit.bind(_this);
		return _this;
	}

	_createClass(EditRole, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.fetchRoleCategoriesRequest();
			this.props.fetchRoleRequest(this.props.match.params.id);
		}
	}, {
		key: 'editRole',
		value: function editRole(role) {
			this.props.editRoleRequest(this.props.match.params.id, role, this.redirectToDashboard);
		}
	}, {
		key: 'redirectToDashboard',
		value: function redirectToDashboard() {
			this.props.fetchRolesRequest(this.props.filter);
			this.props.history.push('/roles');
		}
	}, {
		key: 'cancelEdit',
		value: function cancelEdit() {
			this.props.editRoleCanceled();
			this.redirectToDashboard();
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.props.role === null || this.props.roleCategories === null) {
				return _react2.default.createElement(_CircularProgress2.default, null);
			}

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'h2',
					null,
					'Editar Cargo'
				),
				_react2.default.createElement(_RolesForm2.default, {
					role: this.props.role,
					roleCategories: this.props.roleCategories,
					submit: this.editRole,
					cancel: this.cancelEdit
				})
			);
		}
	}]);

	return EditRole;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {
		role: state.roles.role,
		roleCategories: state.roleCategories.roleCategories
	};
};

var mapDispatchToProps = _extends({}, _roles.actionCreators, _roleCategories.actionCreators);

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EditRole));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29udGFpbmVycy9FZGl0Um9sZS5qcyJdLCJuYW1lcyI6WyJFZGl0Um9sZSIsInByb3BzIiwiZWRpdFJvbGUiLCJiaW5kIiwicmVkaXJlY3RUb0Rhc2hib2FyZCIsImNhbmNlbEVkaXQiLCJmZXRjaFJvbGVDYXRlZ29yaWVzUmVxdWVzdCIsImZldGNoUm9sZVJlcXVlc3QiLCJtYXRjaCIsInBhcmFtcyIsImlkIiwicm9sZSIsImVkaXRSb2xlUmVxdWVzdCIsImZldGNoUm9sZXNSZXF1ZXN0IiwiZmlsdGVyIiwiaGlzdG9yeSIsInB1c2giLCJlZGl0Um9sZUNhbmNlbGVkIiwicm9sZUNhdGVnb3JpZXMiLCJSZWFjdCIsIkNvbXBvbmVudCIsIm1hcFN0YXRlVG9Qcm9wcyIsInN0YXRlIiwicm9sZXMiLCJtYXBEaXNwYXRjaFRvUHJvcHMiLCJyb2xlc0FjdGlvbkNyZWF0b3JzIiwicm9sZUNhdGVnb3JpZXNBY3Rpb25DcmVhdG9ycyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7QUFDQTs7Ozs7Ozs7Ozs7O0lBR01BLFE7OztBQUVMLG1CQUFZQyxLQUFaLEVBQW1CO0FBQUE7O0FBQUEsa0hBQ05BLEtBRE07O0FBR1osUUFBS0MsUUFBTCxHQUFnQixNQUFLQSxRQUFMLENBQWNDLElBQWQsT0FBaEI7QUFDTixRQUFLQyxtQkFBTCxHQUEyQixNQUFLQSxtQkFBTCxDQUF5QkQsSUFBekIsT0FBM0I7QUFDQSxRQUFLRSxVQUFMLEdBQWtCLE1BQUtBLFVBQUwsQ0FBZ0JGLElBQWhCLE9BQWxCO0FBTGtCO0FBTWY7Ozs7c0NBRW1CO0FBQ3RCLFFBQUtGLEtBQUwsQ0FBV0ssMEJBQVg7QUFDQSxRQUFLTCxLQUFMLENBQVdNLGdCQUFYLENBQTRCLEtBQUtOLEtBQUwsQ0FBV08sS0FBWCxDQUFpQkMsTUFBakIsQ0FBd0JDLEVBQXBEO0FBQ0c7OzsyQkFFUUMsSSxFQUFNO0FBQ1gsUUFBS1YsS0FBTCxDQUFXVyxlQUFYLENBQTJCLEtBQUtYLEtBQUwsQ0FBV08sS0FBWCxDQUFpQkMsTUFBakIsQ0FBd0JDLEVBQW5ELEVBQXVEQyxJQUF2RCxFQUE2RCxLQUFLUCxtQkFBbEU7QUFDTjs7O3dDQUVxQjtBQUNyQixRQUFLSCxLQUFMLENBQVdZLGlCQUFYLENBQTZCLEtBQUtaLEtBQUwsQ0FBV2EsTUFBeEM7QUFDTSxRQUFLYixLQUFMLENBQVdjLE9BQVgsQ0FBbUJDLElBQW5CLENBQXdCLFFBQXhCO0FBQ047OzsrQkFFWTtBQUNaLFFBQUtmLEtBQUwsQ0FBV2dCLGdCQUFYO0FBQ0EsUUFBS2IsbUJBQUw7QUFDQTs7OzJCQUVXO0FBQ1gsT0FBSSxLQUFLSCxLQUFMLENBQVdVLElBQVgsS0FBb0IsSUFBcEIsSUFBNEIsS0FBS1YsS0FBTCxDQUFXaUIsY0FBWCxLQUE4QixJQUE5RCxFQUFvRTtBQUNuRSxXQUFPLDhCQUFDLDBCQUFELE9BQVA7QUFDQTs7QUFFSyxVQUNJO0FBQUE7QUFBQTtBQUNJO0FBQUE7QUFBQTtBQUFBO0FBQUEsS0FESjtBQUVSLGtDQUFDLG1CQUFEO0FBQ0MsV0FBTSxLQUFLakIsS0FBTCxDQUFXVSxJQURsQjtBQUVDLHFCQUFnQixLQUFLVixLQUFMLENBQVdpQixjQUY1QjtBQUdDLGFBQVEsS0FBS2hCLFFBSGQ7QUFJQyxhQUFRLEtBQUtHO0FBSmQ7QUFGUSxJQURKO0FBV0g7Ozs7RUE3Q2tCYyxnQkFBTUMsUzs7QUFnRDdCLElBQU1DLGtCQUFrQixTQUFsQkEsZUFBa0IsQ0FBQ0MsS0FBRDtBQUFBLFFBQVk7QUFDbkNYLFFBQU1XLE1BQU1DLEtBQU4sQ0FBWVosSUFEaUI7QUFFbkNPLGtCQUFnQkksTUFBTUosY0FBTixDQUFxQkE7QUFGRixFQUFaO0FBQUEsQ0FBeEI7O0FBS0EsSUFBTU0sa0NBQ0ZDLHFCQURFLEVBRUZDLDhCQUZFLENBQU47O2tCQUtlLDZCQUFXLHlCQUFRTCxlQUFSLEVBQXlCRyxrQkFBekIsRUFBNkN4QixRQUE3QyxDQUFYLEMiLCJmaWxlIjoiRWRpdFJvbGUuanMiLCJzb3VyY2VSb290IjoiL3NyYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBiaW5kQWN0aW9uQ3JlYXRvcnMgfSBmcm9tICdyZWR1eCc7XG5pbXBvcnQgeyBjb25uZWN0IH0gZnJvbSAncmVhY3QtcmVkdXgnO1xuaW1wb3J0IHsgd2l0aFJvdXRlciB9IGZyb20gJ3JlYWN0LXJvdXRlcic7XG5pbXBvcnQgQ2lyY3VsYXJQcm9ncmVzcyBmcm9tICdtYXRlcmlhbC11aS9DaXJjdWxhclByb2dyZXNzJztcbmltcG9ydCB7IGFjdGlvbkNyZWF0b3JzIGFzIHJvbGVzQWN0aW9uQ3JlYXRvcnMgfSBmcm9tICcuLi9hY3Rpb25zL3JvbGVzJztcbmltcG9ydCB7IGFjdGlvbkNyZWF0b3JzIGFzIHJvbGVDYXRlZ29yaWVzQWN0aW9uQ3JlYXRvcnMgfSBmcm9tICcuLi9hY3Rpb25zL3JvbGVDYXRlZ29yaWVzJztcbmltcG9ydCBSb2xlRm9ybSBmcm9tICcuLi9jb21wb25lbnRzL3JvbGVzL1JvbGVzRm9ybSc7XG5cblxuY2xhc3MgRWRpdFJvbGUgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQge1xuXHRcblx0Y29uc3RydWN0b3IocHJvcHMpIHtcbiAgICAgICAgc3VwZXIocHJvcHMpO1xuXG4gICAgICAgIHRoaXMuZWRpdFJvbGUgPSB0aGlzLmVkaXRSb2xlLmJpbmQodGhpcyk7XG5cdFx0dGhpcy5yZWRpcmVjdFRvRGFzaGJvYXJkID0gdGhpcy5yZWRpcmVjdFRvRGFzaGJvYXJkLmJpbmQodGhpcyk7XG5cdFx0dGhpcy5jYW5jZWxFZGl0ID0gdGhpcy5jYW5jZWxFZGl0LmJpbmQodGhpcyk7XG4gICAgfVxuXG4gICAgY29tcG9uZW50RGlkTW91bnQoKSB7XG5cdFx0dGhpcy5wcm9wcy5mZXRjaFJvbGVDYXRlZ29yaWVzUmVxdWVzdCgpO1xuXHRcdHRoaXMucHJvcHMuZmV0Y2hSb2xlUmVxdWVzdCh0aGlzLnByb3BzLm1hdGNoLnBhcmFtcy5pZCk7XG4gICAgfVxuXG4gICAgZWRpdFJvbGUocm9sZSkge1xuICAgICAgICB0aGlzLnByb3BzLmVkaXRSb2xlUmVxdWVzdCh0aGlzLnByb3BzLm1hdGNoLnBhcmFtcy5pZCwgcm9sZSwgdGhpcy5yZWRpcmVjdFRvRGFzaGJvYXJkKTtcblx0fVxuXHRcblx0cmVkaXJlY3RUb0Rhc2hib2FyZCgpIHtcblx0XHR0aGlzLnByb3BzLmZldGNoUm9sZXNSZXF1ZXN0KHRoaXMucHJvcHMuZmlsdGVyKTtcbiAgICAgICAgdGhpcy5wcm9wcy5oaXN0b3J5LnB1c2goJy9yb2xlcycpO1xuXHR9XG5cdFxuXHRjYW5jZWxFZGl0KCkge1xuXHRcdHRoaXMucHJvcHMuZWRpdFJvbGVDYW5jZWxlZCgpO1xuXHRcdHRoaXMucmVkaXJlY3RUb0Rhc2hib2FyZCgpO1xuXHR9XG5cbiAgICByZW5kZXIoKSB7XG5cdFx0aWYgKHRoaXMucHJvcHMucm9sZSA9PT0gbnVsbCB8fCB0aGlzLnByb3BzLnJvbGVDYXRlZ29yaWVzID09PSBudWxsKSB7XG5cdFx0XHRyZXR1cm4gPENpcmN1bGFyUHJvZ3Jlc3MgLz47XG5cdFx0fVxuXG4gICAgICAgIHJldHVybiAoXG4gICAgICAgICAgICA8ZGl2PlxuICAgICAgICAgICAgICAgIDxoMj5FZGl0YXIgQ2FyZ288L2gyPlxuXHRcdFx0XHQ8Um9sZUZvcm0gXG5cdFx0XHRcdFx0cm9sZT17dGhpcy5wcm9wcy5yb2xlfVxuXHRcdFx0XHRcdHJvbGVDYXRlZ29yaWVzPXt0aGlzLnByb3BzLnJvbGVDYXRlZ29yaWVzfVxuXHRcdFx0XHRcdHN1Ym1pdD17dGhpcy5lZGl0Um9sZX1cblx0XHRcdFx0XHRjYW5jZWw9e3RoaXMuY2FuY2VsRWRpdH1cblx0XHRcdFx0Lz5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICApO1xuICAgIH1cbn1cblxuY29uc3QgbWFwU3RhdGVUb1Byb3BzID0gKHN0YXRlKSA9PiAoe1xuXHRyb2xlOiBzdGF0ZS5yb2xlcy5yb2xlLFxuXHRyb2xlQ2F0ZWdvcmllczogc3RhdGUucm9sZUNhdGVnb3JpZXMucm9sZUNhdGVnb3JpZXNcbn0pO1xuXG5jb25zdCBtYXBEaXNwYXRjaFRvUHJvcHMgPSB7XG5cdC4uLnJvbGVzQWN0aW9uQ3JlYXRvcnMsXG5cdC4uLnJvbGVDYXRlZ29yaWVzQWN0aW9uQ3JlYXRvcnNcbn07XG5cbmV4cG9ydCBkZWZhdWx0IHdpdGhSb3V0ZXIoY29ubmVjdChtYXBTdGF0ZVRvUHJvcHMsIG1hcERpc3BhdGNoVG9Qcm9wcykoRWRpdFJvbGUpKTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/client/containers/EditRole.js
// module id = 3289
// module chunks = 0